/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import _ from 'underscore';
import { CheckboxGroup } from '@bingads-webui-react/checkbox';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { SearchBox } from '@bingads-webui-react/search-box-control';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStyles } from './styles';
import Spin from './spin';

const LOADING = 'Loading';
const SUCCEEDED = 'Succeeded';
const FAILED = 'Failed';

export const EmailPicker = (props) => {
  const {
    isScheduleEnabled,
    i18n,
    currentUserEmail,
    emails: selectedEmails,
    onChange: onChangeSelectedEmails,
    loadEmails,
    className,
  } = props;

  const [availableEmails, setAvailableEmails] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [loadEmailsStatus, setLoadEmailsStatus] = useState(LOADING);
  const classes = useDefaultStyles(getStyles);

  useEffect(() => {
    // load emails
    loadEmails()
      .then((emails) => {
        const userEmails = _.uniq(emails);
        // Legacy saved reports may have emails not belong to loaded users
        const allEmails = _.union([currentUserEmail], userEmails, selectedEmails);

        setAvailableEmails(allEmails);

        setLoadEmailsStatus(SUCCEEDED);
      })
      .catch(() => {
        setLoadEmailsStatus(FAILED);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSearch = (query) => {
    setSearchString(query);
  };

  const renderEmail = (email) => {
    if (email === currentUserEmail) {
      return (
        <ReactTemplate
          model={{
            email,
            me: <b>{i18n.getString(_TL_('me'))}</b>,
          }}
          template={i18n.getString(_TL_('{{email}} ({{me}})'))}
        />
      );
    }

    // TODO
    // emailaddress@domain.com (readonly)
    // https://msasg.visualstudio.com/DefaultCollection/Bing_Ads/_git/AdsAppUI?path=%2Fprivate%2FUI%2FCommon%2FMicrosoft.ClientCenter.Repository%2FProxy%2FClientCenterProxyEnums.cs&version=GBmaster&_a=contents&line=215&lineStyle=plain&lineEnd=240&lineStartColumn=1&lineEndColumn=6

    return email;
  };


  const renderEmailList = () => {
    const filteredEmails = availableEmails.filter(email => email.includes(searchString)).sort();

    switch (loadEmailsStatus) {
      case LOADING:
        return <Spin i18n={i18n} />;
      case SUCCEEDED:
        return (
          filteredEmails.length ?
            <CheckboxGroup
              disabled={!isScheduleEnabled}
              items={filteredEmails}
              checked={selectedEmails}
              renderItem={renderEmail}
              getItemId={email => email}
              onChange={emails => onChangeSelectedEmails(emails)}
            /> :
            i18n.getString(_TL_('There are no results available based on your filtered search. Please revise your search.'))
        );
      case FAILED:
        return (
          <div className={classnames('alert', 'alert-warning')} role="alert">
            {i18n.getString(_TL_('Failed to load users'))}
          </div>
        );
      default:
        return null;
    }
  };

  const searchBoxElement = (
    <SearchBox
      isDisabled={!isScheduleEnabled}
      onSearch={onSearch}
      onQueryChange={onSearch}
      value={searchString}
      placeholder={i18n.getString(_TL_('Search users'))}
    />);

  return (
    <div className={`email-notification-delivery-option-editor ${classes['reports-v4-email-picker']} ${className}`}>
      <div className="email-notification-delivery-option-editor__search-box">
        {searchBoxElement}
      </div>
      <div className="email-notification-delivery-option-editor__user-list">
        {renderEmailList()}
      </div>
    </div>
  );
};

EmailPicker.propTypes = {
  isScheduleEnabled: PropTypes.bool.isRequired,
  emails: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  currentUserEmail: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  loadEmails: PropTypes.func.isRequired,
  className: PropTypes.string,
};

EmailPicker.defaultProps = {
  className: '',
};
